import { previewDetailsForGuest, previewDetailsV2 } from "@/api/configPage";
import {
  ConfigPageAuthMode,
  filterGuestModules,
} from "@/hooks/useConfigPage/access";
import { PageDataConfig } from "@/types/config-page";
import { useQuery } from "@tanstack/react-query";

const useFetchConfigPage = ({
  authMode,
  pageCode,
  versionCode,
  previewType,
  shareUid,
  enabled = true,
}: {
  authMode?: ConfigPageAuthMode;
  pageCode?: string;
  versionCode?: string;
  previewType?: string;
  shareUid?: string;
  enabled?: boolean;
}) => {
  const query = useQuery<PageDataConfig>({
    queryKey: [
      "/web-h5/charge/marketingH5Page/findPageConfig",
      authMode,
      pageCode,
      versionCode,
      previewType,
      shareUid,
    ],
    queryFn: async () => {
      const fetchConfig =
        authMode === "guest" ? previewDetailsForGuest : previewDetailsV2;
      const res = await fetchConfig({
        pageCode,
        versionCode,
        previewType,
        shareUid,
      });
      if (res.code !== 200) {
        return null;
      }
      const data = res.data || null;
      if (data && authMode === "guest") {
        return {
          ...data,
          loginRequired: data.loginRequired ?? 1,
          moduleList: filterGuestModules(data.moduleList || []),
        };
      }
      return data;
    },
    refetchOnMount: false,
    enabled,
  });

  return query;
};

export default useFetchConfigPage;
